import React from 'react';
import PropTypes from 'prop-types';

import withSuspense from './withSuspense';


// Ideally LazyIcon would be using React.lazy & lazyWithRetry
function withLazyIconFallback(LazyIcon) {
    function LazyIconFallback({
        className,
        width,
        height,
    }) {
        // Fix for layout jank with lazy loaded icons
        // If we're provided one of width or height, assume our size is a square and set the other size
        const fallbackWidth = width ?? height ?? '100%';
        const fallbackHeight = height ?? width ?? '100%';

        // If the icon is supplied a size either via rh-icon-* class name or width/height props
        //  we want this to also apply to our fallback so the size remains the same before the
        //  icon loads.
        const style = className && className.includes('rh-icon-')
            ? {}
            : { width: fallbackWidth, height: fallbackHeight };

        return (
            <span
                className={className}
                style={style}
            />
        );
    }

    LazyIconFallback.propTypes = {
        className: PropTypes.string,
        width: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        height: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    };


    const WrapperComponent = withSuspense(LazyIcon, LazyIconFallback);

    WrapperComponent.propTypes = {
        className: PropTypes.string,
        width: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        height: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    };

    return WrapperComponent;
}

export default withLazyIconFallback;
